<template>
  <div class="pop_up_wrap">
    <div class="pop_up_content" v-show="has_popup">
      <div class="pop" v-for="pop in popupList" :key="`pop${pop.p_idx}`" :id="`pop${pop.p_idx}`">
        <div class="pop_img" :style="`background-image: url(${returnPopupImage(pop)})`" @click="goDetail(pop.p_idx)"></div>
        <div class="pop_bottom">
          <input class="pop_checkBox" type="checkbox" :id="`checked${pop.p_idx}`" v-model="checkHide[pop.p_idx]">
          <label :for="`checked${pop.p_idx}`"  v-model="checkHide[pop.p_idx]"><span>오늘 하루 보지 않음</span></label>
          <button class="close_btn" @click="hidePop(pop.p_idx)"><span>닫기</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";

export default {
  name: "PopupComponent",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      popupList: [],
      has_popup: false,
      checkHide: {}
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getPopup()
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getPopup() {
      let params = {
        ip: 0,
        isdi: 1
      }
      try {
        this.$api.$popup.getPopup(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type == 1) {
            let today = this.$moment().format('YYYY-MM-DD');
            this.popupList = res.List;
            this.popupList.forEach(pop => {
              this.checkHide[pop.p_idx] = false;
            })
            if (this.popupList.length > 0) {
              this.$forceUpdate();
              let localHidePop = this.$localStorage.get('SafeCheckHidePop');
              let newLocalHidePop = [];
              window.setTimeout(() => {
                this.has_popup = true;
                if (localHidePop != null && localHidePop.length > 0) {
                  localHidePop.forEach(pop => {
                    if (pop.date === today) {
                      let popDiv = document.getElementById(`pop${pop.p_idx}`);
                      if (popDiv) {
                        popDiv.style.display = 'none';
                      }
                    }
                    if (this.$moment(pop.date).isSameOrAfter(today)) {
                      newLocalHidePop.push(pop);
                    }
                  })
                  this.$localStorage.set('SafeCheckHidePop', newLocalHidePop);
                }
              }, 500);
            }
          }
        })
      } catch (e) {
        console.log(e);
      }
    },

    returnPopupImage(pop) {
      return pop.hasOwnProperty('File') ? `${pop.MobileFile[0].org_url}?${this.setImageOptions(650, 860, 'png')}` : ''
    },
    goDetail(p_idx) {
      this.$router.push(`/popup/${p_idx}`)
    },
    hidePop(p_idx) {
      if (this.checkHide[p_idx]) {
        this.hideTodayPop(p_idx)
      } else {
        let popDiv = document.querySelector(`#pop${p_idx}`)
        popDiv.style.display = 'none';
      }
    },
    hideTodayPop(p_idx) {
      let localHidePop = this.$localStorage.get('SafeCheckHidePop');
      if (localHidePop != null && localHidePop.length > 0) {
        let popWrap = localHidePop.filter(pop => pop.p_idx === p_idx);
        if (popWrap.length > 0) {
          localHidePop.forEach(pop => {
            if (pop.p_idx === p_idx) {
              pop.date = this.$moment().format('YYYY-MM-DD')
            }
          });
        } else {
          let hidePop = {
            date: this.$moment().format('YYYY-MM-DD'),
            p_idx: p_idx
          }
          localHidePop.push(hidePop);
        }

      } else {
        localHidePop = [{
          date: this.$moment().format('YYYY-MM-DD'),
          p_idx: p_idx
        }]
      }
      this.$localStorage.set('SafeCheckHidePop', localHidePop);
      let popDiv = document.querySelector(`#pop${p_idx}`)
      popDiv.style.display = 'none';
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>